import { invisiblyApi } from 'src/redux/api/invisibly-api';
import { InvisiblyApiResponse } from 'src/types/apiResponses';
import type {
  CreativeImportPreview,
  CreativeImportRunStatusResponse,
  CreativeImportTriggerResponse,
} from '../types/creative-import.types';

const creativeImportEndpoints = invisiblyApi.injectEndpoints({
  endpoints: (builder) => ({
    getCreativeImportPreview: builder.query<CreativeImportPreview, string>({
      query: (clientId) => ({
        method: 'get',
        url: `client/${clientId}/creative-import/preview`,
      }),
      transformResponse(response: InvisiblyApiResponse<CreativeImportPreview>) {
        return response.item;
      },
      keepUnusedDataFor: 300,
    }),
    triggerCreativeImport: builder.mutation<CreativeImportTriggerResponse, string>({
      query: (clientId) => ({
        method: 'post',
        url: `client/${clientId}/creative-import`,
      }),
      transformResponse(response: InvisiblyApiResponse<CreativeImportTriggerResponse>) {
        return response.item;
      },
    }),
    getCreativeImportStatus: builder.query<
    CreativeImportRunStatusResponse,
    { clientId: string; runId: string }
    >({
      query: ({ clientId, runId }) => ({
        method: 'get',
        url: `client/${clientId}/creative-import/${runId}`,
      }),
      transformResponse(response: InvisiblyApiResponse<CreativeImportRunStatusResponse>) {
        return response.item;
      },
    }),
  }),
  overrideExisting: true,
});

export const {
  useGetCreativeImportPreviewQuery,
  useLazyGetCreativeImportPreviewQuery,
  useTriggerCreativeImportMutation,
  useGetCreativeImportStatusQuery,
} = creativeImportEndpoints;
